import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AlertButtonColor } from "@obg/mat.ui.core";
import {
	AbstractTranslatableAlertService,
	AuthenticationStatus,
	AuthSelector,
	CORE_ROUTE,
	CoreState,
	CustomerManagementSelector,
	DisallowedActionCodes,
} from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { combineLatest } from "rxjs";
import { map } from "rxjs/operators";

const DEPOSIT_LIMIT_REQUIRED_DIALOG = "DEPOSIT_LIMIT_REQUIRED_DIALOG";

@Injectable({
	providedIn: "root",
})
export class DepositLimitService {
	constructor(
		private store: Store<CoreState>,
		private translatableAlertService: AbstractTranslatableAlertService
	) {}

	depositLimitGuard$() {
		return combineLatest([
			this.store.select(AuthSelector.getAuthenticationStatus),
			this.store.select(CustomerManagementSelector.getAllowedAction),
		]).pipe(
			map(([status, actions]) => {
				if (
					status === AuthenticationStatus.Pending ||
					(status === AuthenticationStatus.Authenticated && !actions)
				) {
					return false;
				}
				if (
					!actions?.betSportsbook?.isAllowed &&
					actions?.betSportsbook?.disallowedReasons.includes(
						DisallowedActionCodes.M_CURRENTCUSTOMER_DEPOSITLIMITUNSET
					)
				) {
					this.translatableAlertService.open(
						{
							id: DEPOSIT_LIMIT_REQUIRED_DIALOG,
							title: "multi-deposit-limit.title",
							message: "multi-deposit-limit.description",
							hideClose: true,
							dialogConfig: {
								disableClose: true,
							},
							mustBeInteracted: true,
							buttons: [
								{
									text: "general.cancel",
									handler: () => {
										this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
									},
								},
								{
									color: AlertButtonColor.Primary,
									text: `multi-deposit-limit.set-limit`,
									handler: () => {
										this.store.dispatch(
											RouteAction.navigate(CORE_ROUTE.responsibleGaming.depositLimit)
										);
									},
								},
							],
						},
						[]
					);
					return false;
				}

				return true;
			})
		);
	}
}
